module.exports = __webpack_public_path__ + "img/allergies.7b179a77.svg";